/* eslint-disable @typescript-eslint/no-var-requires */
import { layout } from '../../../App.routing'
import { GetMainSectionFn } from '../custom-topic-routes'

const fatherJoeDesktopX2 = require<
    string
>('./assets/father-joe/TW-father-joe-desktop-1220x150@2x.jpg')

const fatherJoeDesktopX1 = require<
    string
>('./assets/father-joe/TW-father-joe-desktop-1220x150.jpg')

const fatherJoeTabletX2 = require<
    string
>('./assets/father-joe/TW-father-joe-tablet-738x57@2x.jpg')

const fatherJoeTabletX1 = require<
    string
>('./assets/father-joe/TW-father-joe-tablet-738x57.jpg')

const fatherJoeMobileX2 = require<
    string
>('./assets/father-joe/TW-father-joe-mobile-411x93@2x.jpg')

const fatherJoeMobileX1 = require<
    string
>('./assets/father-joe/TW-father-joe-mobile-411x93.jpg')

export const getSubscriberFeaturesRouteInfo: GetMainSectionFn = ({
    getCuratedSection,
}) => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: fatherJoeDesktopX2,
                verticalGutters: ['unset', 'md'],
                altText:
                    'Father Joe - Saint or Sinner, A Special Investigation',
                sources: [
                    {
                        breakpoint: 'md',
                        src: [
                            { src: fatherJoeDesktopX2, density: '2x' },
                            { src: fatherJoeDesktopX1, density: '1x' },
                        ],
                    },
                    {
                        breakpoint: 'xs',
                        src: [
                            { src: fatherJoeTabletX2, density: '2x' },
                            { src: fatherJoeTabletX1, density: '1x' },
                        ],
                    },
                    {
                        src: [
                            { src: fatherJoeMobileX2, density: '2x' },
                            { src: fatherJoeMobileX1, density: '1x' },
                        ],
                    },
                ],
            },
        }),
        ...getCuratedSection({
            lima: {
                verticalSpacing: 'xl',
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['commonWithBackground', 'titleOnly'],
                ],

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'features',
                    offset: 2,
                    pageSize: 5,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fixedRatios: ['16:9'],
                finalColumns: 4,
                stretchSelf: true,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['titleOnly', 'titleOnly', 'titleOnly', 'titleOnly'],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'Claremont Serial Killings',
                    headingUrl: '/news/claremont-serial-killings',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['news/claremont-serial-killings'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 7,
                    },
                },
            },
        }),

        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fixedRatios: ['16:9'],
                finalColumns: 4,
                stretchSelf: true,
                cardLayout: [
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Gerard Ross Episodes`,
                    headingUrl: '/features/gerard-ross',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'gerard-ross',
                    offset: 1,
                    pageSize: 8,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Jody Gore`,
                    headingUrl: '/features/jody-gore',
                    section: 'generic',
                },
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                ],

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['features/jody-gore'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 6,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Father Joe`,
                    headingUrl: '/features/father-joe',
                    section: 'generic',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['features/father-joe'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Bush and 'Burbs`,
                    headingUrl: '/sport/bush-and-burbs',
                    section: 'generic',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/bush-and-burbs'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Flashpoint`,
                    headingUrl: '/news/flashpoint',
                    section: 'generic',
                },
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                    ['teaserWithBackground'],
                ],
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['news/flashpoint'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 6,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                sectionHeader: {
                    heading: `Most Influential`,
                    section: 'generic',
                },
                verticalSpacing: 'xl',
                fixedRatios: ['16:9'],
                finalColumns: 4,
                stretchSelf: true,

                cardLayout: [
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                ],
                cardOrientation: { type: 'Landscape-Portrait' },
                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'most-influential',
                    offset: 0,
                    pageSize: 8,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Red Tape War`,
                    headingUrl: '/features/red-tape-war',
                    section: 'generic',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['features/red-tape-war'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Shalom House`,
                    headingUrl: '/features/shalom-house',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    sortResultsInChornologicalOrder: true,
                    type: 'listing',
                    topics: ['features/shalom-house'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.nestedComposition({
            type: 'janus',
            props: {
                stretchColumns: true,
                verticalSpacing: 'lg',
            },
            contentAreas: {
                left: [
                    layout.component({
                        type: 'lima',
                        props: {
                            sectionHeader: {
                                heading: `Secret Police Files`,
                                section: 'generic',
                            },
                            verticalSpacing: 'xs',
                            fontScale: 1.2,
                            fixedRatios: ['16:9'],
                            hasBackground: true,
                            initialColumns: 1,
                            finalColumns: 2,
                            cardOrientation: { type: 'Landscape-Portrait' },

                            cardLayout: [
                                ['teaserWithBackground'],
                                ['teaserWithBackground'],
                            ],
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['features/secret-police-files'],
                                includeSubTopics: false,
                                paging: {
                                    page: 0,
                                    pageSize: 2,
                                },
                            },
                        },
                    }),
                ],
                right: [
                    layout.component({
                        type: 'lima',
                        props: {
                            sectionHeader: {
                                heading: `The Kid`,
                                section: 'generic',
                            },
                            verticalSpacing: 'xs',
                            fontScale: 1.2,
                            fixedRatios: ['16:9'],
                            hasBackground: true,
                            initialColumns: 1,
                            finalColumns: 2,

                            cardOrientation: { type: 'Landscape-Portrait' },
                            cardLayout: [
                                ['teaserWithBackground'],
                                ['teaserWithBackground'],
                            ],
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: ['features/the-kid'],
                                includeSubTopics: false,
                                paging: {
                                    page: 0,
                                    pageSize: 2,
                                },
                            },
                        },
                    }),
                ],
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: `Footy's Most Powerful`,
                    headingUrl: '/features/footys-most-powerful',
                    section: 'generic',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['features/footys-most-powerful'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'The Kerry Stokes Collection',
                    headingUrl: '/features/kerry-stokes-collection',
                    section: 'generic',
                },
                cardLayout: [
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    ['teaserWithBackground'],
                    [
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                        {
                            type: 'landscape',
                            format: 'landscape-smTeaser-mdNoTeaser',
                        },
                    ],
                ],

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['features/kerry-stokes-collection'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 6,
                    },
                },
            },
        }),
    ]
}
